import { useDispatch } from 'react-redux';
import { setSnackbar } from '../../redux/snackbar';

export default function ErrorParcela(
  message = 'Erro ao colocar valor da parcela acima do valor total da conta!',
) {
  const dispatch = useDispatch();

  return () => {
    dispatch(setSnackbar(true, 'error', message));
  };
}
